<template>

    <div>

        <div class="row">

            <div class="col">

                <div class="row">
                    <div class="col-6">
                        <button class="btn btn-primary btn-sm mb-4" @click="openUploadFileModal">{{ t.__('Prześlij plik') }}</button>
                    </div>
                    <div class="col-6 text-right">
                        <a :href="route('active-cues::software.toggle-autoupdate', {repo: repo})" class="btn btn-sm mb-4" :class="{'btn-success': autoupdate, 'btn-danger': !autoupdate}">Autoupdate: {{ autoupdate ? 'tak' : 'nie' }}</a>
                    </div>
                </div>

                <table class="table">
                    <thead>
                        <tr>
                            <th><strong>{{ t.__('Nazwa') }}</strong></th>
                            <th><strong>{{ t.__('Rozmiar') }}</strong></th>
                            <th><strong>{{ t.__('Data modyfikacji') }}</strong></th>
                            <th class="text-center"><strong>{{ t.__('Domyślny') }}</strong></th>
                            <th><strong>{{ t.__('Plik pendrive') }}</strong></th>
                            <th><strong>{{ t.__('Data modyfikacji pliku pendrive') }}</strong></th>
                            <th style="width: 125px;"><strong>{{ t.__('Akcje') }}</strong></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="file in files">
                            <td>{{ file.name }}</td>
                            <td>{{ file.size | humanFileSize }}</td>
                            <td>{{ file.modified_at | formatDate }}</td>
                            <td class="text-center"><i class="fa fa-check text-success" v-show="file.default"></i></td>
                            <td>
                                <a v-if="file.pendrive_file" :href="file.pendrive_file.url" target="_blank">{{ file.pendrive_file.name }}</a>
                                <span v-if="file.pendrive_file === null">---</span>
                            </td>
                            <td>
                                <span v-if="file.pendrive_file">{{ file.pendrive_file.modified_at | formatDate }}</span>
                                <span v-if="file.pendrive_file === null">---</span>
                            </td>
                            <td>
                                <button class="btn btn-icon btn-success btn-sm m-0" @click="makeFileDefault(file.name)" :title="t.__('Oznacz jako domyślny')">
                                    <i class="fa fa-check"></i>
                                </button>
                                <button class="btn btn-icon btn-warning btn-sm m-0" @click="generatePendriveFile(file.name)" :title="t.__('Generuj plik pendrive')">
                                    <i class="fa fa-usb"></i>
                                </button>
                                <button class="btn btn-icon btn-danger btn-sm m-0" @click="deleteFile(file.name)" :title="t.__('Usuń')">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>

            <b-modal
                id="upload-file-modal"
                size="sm"
                :title="t.__('Prześlij plik')"
                :ok-title="t.__('Prześlij')"
                :cancel-title="t.__('Anuluj')"
                :ok-disabled="uploadProgress > 0"
                :cancel-disabled="uploadProgress > 0"
                ok-variant="primary"
                no-close-on-backdrop
                @ok="uploadFileModalHandleOk">
                <div class="alert alert-warning" role="alert" v-if="fileAlreadyExists">
                    {{ t.__('Plik o wybranej nazwie już istnieje w repozytorium. Potwierdź ponownie przesłanie pliku w celu jego nadpisania, lub wybierz nową nazwę.') }}
                </div>
                <b-form-file v-model="uploadFile" accept=".tar.gz, .tgz" :placeholder="t.__('Wybierz plik do przesłania...')" :drop-placeholder="t.__('Upuść plik tutaj...')"></b-form-file>
                <div class="form-group mt-3" v-if="fileAlreadyExists">
                    <label for="file_name">{{ t.__('Nazwa pliku') }}</label>
                    <input type="text" class="form-control" id="file_name" v-model="fileName">
                </div>

                <div class="progress mt-3" style="height: 20px;" v-show="uploadProgress > 0">
                    <div class="progress-bar" :style="'height: 20px; width: ' + uploadProgress + '%'">{{ uploadProgress }}%</div>
                </div>
            </b-modal>

        </div>

    </div>

</template>

<script>

    import dayjs from "dayjs";

    export default {

        name: 'ActiveCuesSoftware',

        props: [
            'repo',
            'filesInput',
            'autoupdate'
        ],

        data() {
            return {
                eventHub: window.eventHub,
                files: [],
                uploadFile: null,
                uploadProgress: 0,
                fileAlreadyExists: false,
                fileName: null
            }
        },

        computed: {

        },

        beforeMount() {

            this.files = this.filesInput;

        },

        mounted() {

            console.log(this.files);

        },

        filters:{
            formatDate: (timestamp, format = 'DD.MM.YYYY HH:mm:ss') => {
                let date = new Date(timestamp * 1000);
                return dayjs(date).format(format);
            },
            humanFileSize: function (num) {
                if (typeof num !== 'number' || isNaN(num)) {
                    throw new TypeError('Expected a number');
                }

                let exponent;
                let unit;
                let neg = num < 0;
                let units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                if (neg) {
                    num = -num;
                }

                if (num < 1) {
                    return (neg ? '-' : '') + num + ' B';
                }

                exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
                num = (num / Math.pow(1000, exponent)).toFixed(0) * 1;
                unit = units[exponent];

                return (neg ? '-' : '') + num + ' ' + unit;
            }
        },

        methods: {

            openUploadFileModal() {
                this.$bvModal.show('upload-file-modal');
            },

            uploadFileModalHandleOk(event) {
                event.preventDefault();

                if (this.fileAlreadyExists === false) {
                    this.eventHub.$emit('processing-start');
                    axios.post(route('active-cues::software.check-if-file-name-already-taken', {repo: this.repo}), {file_name: this.uploadFile.name})
                        .then(response => {
                            this.eventHub.$emit('processing-finish');
                            if (response.data.data.file_exists) {
                                this.fileAlreadyExists = true;
                                this.fileName = this.uploadFile.name;
                            } else {
                                this.processFileUpload();
                            }
                        })
                        .catch(error => {
                            console.log(error.response);
                            this.eventHub.$emit('processing-finish');
                            if (error.response.data.message) {
                                this.eventHub.$emit('toast-notification', error.response.data.message, 'error');
                            } else {
                                this.eventHub.$emit('toast-notification', t.__('Coś poszło nie tak.'), 'error');
                            }
                        });
                } else {
                    this.processFileUpload();
                }

            },

            processFileUpload() {
                let formData = new FormData();
                formData.append('file', this.uploadFile);
                if (this.fileName !== null) {
                    formData.append('file_name', this.fileName);
                }
                axios.post(route('active-cues::software.upload-file', {repo: this.repo}), formData, {
                    onUploadProgress: (progressEvent) => {
                        const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
                        if (totalLength !== null) {
                            this.uploadProgress = Math.round((progressEvent.loaded * 100) / totalLength);
                        }
                    }
                })
                    .then(response => {
                        this.files = response.data.data.files;
                        this.$bvModal.hide('upload-file-modal');
                        this.uploadFile = null;
                        this.uploadProgress = 0;
                        this.fileAlreadyExists = false;
                        this.fileName = null;
                        this.eventHub.$emit('toast-notification', response.data.message, 'success');
                    })
                    .catch(error => {
                        console.log(error.response);
                        this.uploadProgress = 0;
                        if (error.response.data.message) {
                            this.eventHub.$emit('toast-notification', error.response.data.message, 'error');
                        } else {
                            this.eventHub.$emit('toast-notification', t.__('Coś poszło nie tak.'), 'error');
                        }
                    });
            },

            makeFileDefault(file) {
                event.preventDefault();
                this.eventHub.$emit('processing-start');
                axios.get(route('active-cues::software.make-file-default', {repo: this.repo, file: file}))
                    .then(response => {
                        this.files = response.data.data.files;
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', response.data.message, 'success');
                    })
                    .catch(error => {
                        console.log(error.response);
                        this.eventHub.$emit('processing-finish');
                        if (error.response.data.message) {
                            this.eventHub.$emit('toast-notification', error.response.data.message, 'error');
                        } else {
                            this.eventHub.$emit('toast-notification', t.__('Coś poszło nie tak.'), 'error');
                        }
                    });
            },

            generatePendriveFile(file) {
                event.preventDefault();
                this.eventHub.$emit('processing-start');
                axios.get(route('active-cues::software.generate-pendrive-file', {repo: this.repo, file: file}))
                    .then(response => {
                        this.files = response.data.data.files;
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', response.data.message, 'success');
                    })
                    .catch(error => {
                        console.log(error.response);
                        this.eventHub.$emit('processing-finish');
                        if (error.response.data.message) {
                            this.eventHub.$emit('toast-notification', error.response.data.message, 'error');
                        } else {
                            this.eventHub.$emit('toast-notification', t.__('Coś poszło nie tak.'), 'error');
                        }
                    });
            },

            deleteFile(file) {
                event.preventDefault();
                this.eventHub.$emit('processing-start');
                axios.delete(route('active-cues::software.delete-file', {repo: this.repo, file: file}))
                    .then(response => {
                        this.files = response.data.data.files;
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', response.data.message, 'success');
                    })
                    .catch(error => {
                        console.log(error.response);
                        this.eventHub.$emit('processing-finish');
                        if (error.response.data.message) {
                            this.eventHub.$emit('toast-notification', error.response.data.message, 'error');
                        } else {
                            this.eventHub.$emit('toast-notification', t.__('Coś poszło nie tak.'), 'error');
                        }
                    });
            }

        }

    }
</script>

<style scoped>

    .custom-file-input ~ .custom-file-label::after {
        content: 'Wybierz';
    }

</style>
